import {toSafePathSegment} from '@/utils/security/pathSafety'

export const FILE_UPLOAD_CONFIG = {
  UPLOAD_FILE: {
    endPoint: 'upload-file', //needed to be changed when api is available
    method: 'POST',
  },
  UPLOAD_BULK_MODIFIER_FILE: {
    endPoint: 'bulk-point-modifier/stores-upload-csv/product', //For bulk point modifiers
    method: 'POST',
  },
  UPLOAD_SALES_TARGET_CONTENT: {
    endPoint: 'sale-targets/uploadMedia', //For sales Target
    method: 'POST',
    contentType: 'multipart/form-data',
    headers: {Accept: '*/*'},
    multipart: 'multipart',
  },
  TEMPLATE_UPLOAD: {
    endPoint: 'template/upload', //For sales Target
    method: 'GET',
    baseUrlKey: 'inventoryApiUrl',
    // contentType: 'multipart/form-data',
    // headers: {Accept: '*/*'},
    // multipart: 'multipart',
  },
  METADATA: {
    endPoint: 'file/metadata',
    method: 'POST',
    baseUrlKey: 'inventoryApiUrl',
    headers: {
      scope: 'pepsi',
    },
  },
  PUBLISH_PRODUCT_LIST: uuid => ({
    endPoint: `file/${toSafePathSegment(uuid)}/metadata`,
    method: 'PATCH',
    baseUrlKey: 'inventoryApiUrl',
    headers: {
      scope: 'pepsi',
    },
  }),
  UPLOAD_BULK_PROMOTION_FILE: {
    endPoint: 'promotion/bulk-upload',
    method: 'POST',
    contentType: 'multipart/form-data',
    baseUrlKey: 'inventoryApiUrl',
    headers: {
      scope: 'pepsi',
    },
  },
  UPLOAD_SUGGESTED_SKUS: {
    endPoint: 'suggested-skus/process',
    method: 'POST',
    contentType: 'multipart/form-data',
    baseUrlKey: 'inventoryApiUrl',
    headers: {
      scope: 'pepsi',
    },
  },
}
